import React from "react";
import { ReactElement } from "react";
import { LijfrenteUitkeringHoofdstuk } from "../../../../.generated/rapportage/rapportagetypes";
import Table from "../../components/Table";
import Heading from "../../components/Heading";
import { Chapter } from "../../components/Chapter";
import { Paragraph } from "../../components/Paragraph";
import { getLijfrentesColumns } from "../Producten/lijfrentes-kolommen";

type LijfrentesProps = {
  lijfrentesHoofdstuk: LijfrenteUitkeringHoofdstuk;
};

const getLijfrentesTables = (
  lijfrentesHoofdstuk: LijfrenteUitkeringHoofdstuk
): ReactElement[] => {
  if (
    !lijfrentesHoofdstuk.lijfrenteUitkeringen ||
    lijfrentesHoofdstuk.lijfrenteUitkeringen.length === 0
  ) {
    return [];
  }

  return lijfrentesHoofdstuk.lijfrenteUitkeringen.map((lijfrente, index) => (
    <Table
      key={`lijfrente-table-${index}`}
      columns={getLijfrentesColumns(lijfrente.soortLijfrente)}
      data={[lijfrente]}
      id={`lijfrentes-table-${index}`}
      rotate
      className={"break-avoid"}
      filterNullAnd0Columns
    />
  ));
};

export const LijfrentesChapter = ({
  lijfrentesHoofdstuk,
}: LijfrentesProps): ReactElement => {
  return (
    <Chapter>
      <div className="break-avoid">
        {lijfrentesHoofdstuk.titel && (
          <Heading text={`${lijfrentesHoofdstuk.titel}`} level={3}></Heading>
        )}
        <Paragraph paragraaf={lijfrentesHoofdstuk?.paragrafen?.["305060801"]} />

        {getLijfrentesTables(lijfrentesHoofdstuk)}
      </div>
    </Chapter>
  );
};
